var _rect, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAaDiscountsLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#0860C4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 23V20C29 17.2386 26.7614 15 24 15C21.2386 15 19 17.2386 19 20V23M20.8 33H27.2C28.8802 33 29.7202 33 30.362 32.673C30.9265 32.3854 31.3854 31.9265 31.673 31.362C32 30.7202 32 29.8802 32 28.2V27.8C32 26.1198 32 25.2798 31.673 24.638C31.3854 24.0735 30.9265 23.6146 30.362 23.327C29.7202 23 28.8802 23 27.2 23H20.8C19.1198 23 18.2798 23 17.638 23.327C17.0735 23.6146 16.6146 24.0735 16.327 24.638C16 25.2798 16 26.1198 16 27.8V28.2C16 29.8802 16 30.7202 16.327 31.362C16.6146 31.9265 17.0735 32.3854 17.638 32.673C18.2798 33 19.1198 33 20.8 33Z",
    stroke: "#1D2939",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaDiscountsLock);
export default __webpack_public_path__ + "static/media/aa-discounts-lock.58aa6ae027f1d0503d17b3e1a6223036.svg";
export { ForwardRef as ReactComponent };